import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

export function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()

  if (loading) {
    return <div>Loading...</div>
  }

  if (!user) {
    return <Navigate to="/" />
  }

  return <>{children}</>
}